// extracted by mini-css-extract-plugin
export default {"container":"EditUsergroups_container__B2dwY","loader":"EditUsergroups_loader__tb7tn","new":"EditUsergroups_new__4mvgc"};